import { createEvent, createStore } from 'effector';

type TStore = { isOpen: boolean; type: 'send' | 'receive' | 'default' };
export const setMobileData = createEvent<TStore>();
export const $openMobile = createStore<TStore>({
  isOpen: false,
  type: 'default',
}).on(setMobileData, (_, payload) => payload);
